import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { flattenReturnPortalsFromStores, getSelectedReturnPortal, getSelectedStore } from '@/common/helpers/helpers'
import routes from '@/Router/routes.constants'

const useImpersonationLogin = ({ getShopInfo, getUserProfile, updateContext, location }) => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  useEffect(() => {
    const token = searchParams.get('token')
    if (token) {
      const handleTokenLogin = async () => {
        try {
          localStorage.jwt = token
          localStorage.isImpersonating = 'true'
          localStorage.removeItem('refresh')

          const shopInfo = await getShopInfo()
          const userInfo = await getUserProfile()

          const selectedStore = getSelectedStore(shopInfo.stores, userInfo?.default_store_id)
          const returnPortals = flattenReturnPortalsFromStores(shopInfo.stores)

          updateContext(info => ({
            ...info,
            ...shopInfo,
            userInfo,
            selectedStore,
            returnPortals,
            selectedReturnPortal: getSelectedReturnPortal(returnPortals, selectedStore?.default_portal_id),
          }))

          const next = searchParams.get('next')
          navigate(next || routes.dashboardPage, { state: { from: location } })
        } catch (err) {
          setError(err.errorMessage)
          localStorage.removeItem('jwt')
          localStorage.removeItem('isImpersonating')
        }
      }
      handleTokenLogin()
    }
  }, [searchParams, getShopInfo, getUserProfile, updateContext, navigate, location])

  return { error }
}

export default useImpersonationLogin
